import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import classname from "classnames";


import { connect } from "react-redux";
import menu from "common/data/sideMenu";
import AccessControlWrapper from "components/Common/PermissionButton";
import { mergeMenuEntries } from "helpers/menu_merge_helper";

const Navbar = props => {

  const [userAppMenu, setUserAppMenu] = useState(menu);
  const { userMenu } = props;

  useEffect(() => {
    if (userMenu?.length > 0) {
      const finalAppMenu = mergeMenus(menu, userMenu);
      setUserAppMenu(finalAppMenu);
    }
  }, [userMenu]);

  function mergeMenus(frontendMenus, backendMenus) {
    return processMenuGroups(mergeMenuEntries(frontendMenus, backendMenus));
  }

  function processMenuGroups(menuItems) {
    const result = [];
    const groupedItems = {};
    const groupFirstIndex = {};

    menuItems.forEach(item => {
      if (!item.menuGroup) {
        result[item.originalIndex] = item;
      } else {
        if (!groupedItems[item.menuGroup]) {
          groupedItems[item.menuGroup] = [];
          groupFirstIndex[item.menuGroup] = item.originalIndex;
        }
        groupedItems[item.menuGroup].push(item);
      }
    });

    Object.keys(groupedItems).forEach(groupName => {
      const children = groupedItems[groupName];
      children.sort((a, b) => a.originalIndex - b.originalIndex);

      let groupIcon = <i className="bx bx-folder-open"></i>;
      if (groupName.toLowerCase().includes('transaction')) {
        groupIcon = <i className="bx bx-transfer-alt"></i>;
      } else if (groupName.toLowerCase().includes('reconcil')) {
        groupIcon = <i className="bx bx-check-double"></i>;
      } else if (groupName.toLowerCase().includes('cashback')) {
        groupIcon = <i className="bx bx-time-five"></i>;
      } else if (groupName.toLowerCase().includes('banking')) {
        groupIcon = <i className="bx bx-credit-card"></i>;
      } else if (groupName.toLowerCase().includes('service')) {
        groupIcon = <i className="bx bx-wrench"></i>;
      }

      const parentItem = {
        name: groupName,
        href: "#",
        contextUri: "",
        actionType: "",
        icon: groupIcon,
        isParent: true,
        children: children,
        originalIndex: groupFirstIndex[groupName]
      };
      result[groupFirstIndex[groupName]] = parentItem;
    });

    return result.filter(item => item).sort((a, b) => a.originalIndex - b.originalIndex);
  }


  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    if (ul) {
      var items = ul.getElementsByTagName("a");
      for (var i = 0; i < items.length; ++i) {
        if (props.location.pathname === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    }
  });

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("active"); // li
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active"); // li
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("active"); // li
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("active"); // li
              const parent6 = parent5.parentElement;
              if (parent6) {
                parent6.classList.add("active"); // li
              }
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {userAppMenu?.map((menuItem, index) => (
                  <li key={index} className={menuItem.isParent ? "nav-item dropdown" : "nav-item"}>
                    {menuItem.isParent ? (
                      <>
                        <a
                          className="nav-link dropdown-toggle arrow-down"
                          href="#"
                          id={`topnav-${index}`}
                          role="button"
                        >
                          {menuItem.icon}
                          <span className="ms-2">{menuItem.name}</span>
                        </a>
                        <div className="dropdown-menu">
                          {menuItem.children?.map((childItem, childIndex) => (
                            childItem.contextUri && childItem.actionType ? (
                              <AccessControlWrapper
                                key={childIndex}
                                actionType={childItem.actionType}
                                contextUri={childItem.contextUri}
                              >
                                <Link
                                  to={childItem.href}
                                  className="dropdown-item"
                                >
                                  {childItem.name}
                                </Link>
                              </AccessControlWrapper>
                            ) : (
                              <Link
                                key={childIndex}
                                to={childItem.href}
                                className="dropdown-item"
                              >
                                {childItem.name}
                              </Link>
                            )
                          ))}
                        </div>
                      </>
                    ) : (
                      <AccessControlWrapper
                        actionType={menuItem.actionType}
                        contextUri={menuItem.contextUri}
                      >
                        <Link
                          to={menuItem.href}
                          className="nav-link"
                        >
                          {menuItem.icon}
                          <span className="ms-2">{menuItem.name}</span>
                        </Link>
                      </AccessControlWrapper>
                    )}
                  </li>
                ))}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  appInfo: PropTypes.object,
  userMenu: PropTypes.array,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})((Navbar))
);